module.exports = __webpack_public_path__ + "img/01.351c471d.png";